<template>
    <div>
        <b-modal
            id="multipleVitalModal"
            ref="multipleVitalModal"
            :lazy="true"
            title-tag="h2"
            title="Vitals"
        >
            <!-- Modal Form -->
            <b-form>
                <b-alert show variant="warning" v-if="is_locked">
                    {{ locked.message }}
                </b-alert>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Patient:</label>
                    <div class="col-sm-9 col-form-label">
                        {{ patient ? patient.name : "" }}
                    </div>
                </div>
                <b-form-group
                    label="Date:"
                    class
                    :label-cols="labelCols"
                    label-for="time"
                >
                    <vet-datetime
                        id="time"
                        :disabled="is_locked"
                        v-model="time"
                        v-validate="'required'"
                        :placeholder="{
                            date: 'Date (required)',
                            time: 'Time (required)'
                        }"
                        :inner-class="{
                            'border-danger': errors.has('time')
                        }"
                        container="#multipleVitalModal"
                        rules="required"
                        name="time"
                    ></vet-datetime>
                </b-form-group>
                <div v-for="(vital, index) in vitals" :key="vital.id">
                    <b-form-group
                        :label="vital.master_vital.vital + ':'"
                        class
                        :label-cols="labelCols"
                        :label-for="`vital-${index}`"
                    >
                        <div class="form-inline">
                            <b-form-input
                                :id="`vital-${index}`"
                                :disabled="is_locked"
                                v-model="vitalValues[vital.id]"
                                class="form-control mr-2"
                                style="width: 15.7rem;"
                                type="number"
                                min="0"
                                step="1"
                                placeholder="Value"
                                :value="vital.value"
                                name="vital[]"
                            />
                            <b-form-select
                                v-model="uomID[vital.master_vital.id]"
                                :id="`uom-${index}`"
                                :disabled="is_locked"
                                :options="uom_label(vital.master_vital.id)"
                                name="uomID[]"
                                class="form-control ml-0 col-3"
                            >
                            </b-form-select>
                        </div>
                    </b-form-group>
                </div>
                <b-form-group
                    label="Notes:"
                    class
                    :label-cols="labelCols"
                    label-for="notes"
                >
                    <b-form-textarea
                        id="notes"
                        :disabled="is_locked"
                        v-model="note"
                        name="notes"
                        class="form-control"
                        placeholder="Notes (optional)"
                        rows="3"
                    ></b-form-textarea>
                </b-form-group>
            </b-form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    @click="$refs.multipleVitalModal.hide()"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <div v-if="!loading">
                        <b-button
                            v-if="!isTreatmentboardNew || event.isOpenFromSoap"
                            :disabled="is_locked"
                            class="float-left"
                            variant="primary"
                            @click="save"
                            >Complete</b-button
                        >
                        <b-button-group v-else-if="isTreatmentboardNew">
                            <b-dropdown
                                @click="save"
                                :disabled="is_locked"
                                left
                                split
                                variant="primary"
                                text="Complete"
                            >
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'schedule.treatmentboard.update'
                                        ) && activity.status === 3
                                    "
                                    @click="
                                        triggerTreatmentboardAction(
                                            'reactivate'
                                        )
                                    "
                                    >Reactivate</b-dropdown-item
                                >
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'schedule.treatmentboard.update'
                                        ) && activity.status !== 3
                                    "
                                    @click="triggerTreatmentboardAction('edit')"
                                    >Edit</b-dropdown-item
                                >
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'schedule.treatmentboard.create'
                                        ) && activity.status !== 3
                                    "
                                    @click="
                                        triggerTreatmentboardAction('duplicate')
                                    "
                                    >Duplicate</b-dropdown-item
                                >
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'schedule.treatmentboard.delete'
                                        ) && activity.status === 0
                                    "
                                    @click="
                                        triggerTreatmentboardAction(
                                            'deactivate'
                                        )
                                    "
                                    >Deactivate</b-dropdown-item
                                >
                                <b-dropdown-item
                                    v-if="
                                        _hasAccess(
                                            'schedule.treatmentboard.delete'
                                        ) && activity.status === 1
                                    "
                                    @click="
                                        triggerTreatmentboardAction('delete')
                                    "
                                    >Delete</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="
                                        triggerTreatmentboardAction('history')
                                    "
                                    >History</b-dropdown-item
                                >
                            </b-dropdown>
                        </b-button-group>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { DateTime } from "luxon";
import { some } from "lodash";
import vetDatetime from "@/module/commons/date-time-picker.vue";
export default {
    components: {
        vetDatetime
    },
    data() {
        return {
            loading: true,
            continues: true,
            action: "create",
            time: DateTime.local(),
            note: "",
            uomID: [],
            patient: [],
            activity: [],
            vitals: [],
            vitalValues: [],
            isTreatmentboardNew: false,
            event: null
        };
    },
    computed: {
        labelCols() {
            return 3;
        },
        locked() {
            return this.activity && this.activity.id
                ? this.$store.getters.locked(this.activity.id)
                : null;
        },
        is_locked() {
            return some(this.locked);
        }
    },
    methods: {
        open(event) {
            this.loading = true;
            this.continues = true;
            this.event = event;

            this.patient = event.patient;
            this.time = DateTime.local().setZone(this._timeZone);
            this.isTreatmentboardNew = event.isTreatmentboardNew;

            let self = this;
            self.$refs.multipleVitalModal.show();
            return this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "schedule/activity/" +
                        event.activity.id
                )
                .then(function (response) {
                    if (response && response.data.response) {
                        self.activity = response.data.response.resources;
                        self.note = self.activity.note;

                        // --- edit
                        if (self.activity.vitals.length > 0) {
                            self.vitals = self.activity.vitals;
                            self.action = "edit";
                            $.each(self.vitals, function (key, item) {
                                self.vitalValues[item.id] = item.value;
                                switch (item.master_vital_id) {
                                    case 1:
                                        self.uomID[item.master_vital_id] =
                                            item.master_uom_id;
                                        break;
                                    case 2:
                                        self.uomID[item.master_vital_id] =
                                            item.master_uom_id;
                                        break;
                                    case 3:
                                        self.uomID[item.master_vital_id] =
                                            item.master_uom_id;
                                        break;
                                    case 4:
                                        self.uomID[item.master_vital_id] =
                                            item.master_uom_id;
                                        break;
                                    case 6:
                                        self.uomID[item.master_vital_id] =
                                            item.master_uom_id;
                                        break;

                                    default:
                                        break;
                                }
                            });
                        }
                        // --- create
                        else {
                            if (self.activity.treatment_vitals.length > 0) {
                                self.vitals = self.activity.treatment_vitals.map(
                                    (item, index) => ({
                                        id: index,
                                        value: "",
                                        master_vital: item.master_vital,
                                        master_uom: item.master_uom,
                                        is_new: true
                                    })
                                );
                                $.each(self.vitals, function (key, item) {
                                    self.uomID[item.master_vital.id] =
                                        item.master_uom.id;

                                    if (item.master_vital.id === 4) {
                                        self.uomID[item.master_vital.id] =
                                            self._setting.weights_measures === 1
                                                ? 75
                                                : 72;
                                    }

                                    if (item.master_vital.id === 3) {
                                        self.uomID[item.master_vital.id] =
                                            self._setting.weights_measures === 1
                                                ? 70
                                                : 69;
                                    }
                                });
                            }
                        }

                        self.loading = false;
                    }
                });
        },
        async save() {
            let self = this;
            let response = false;
            let valid = await self.$validator.validateAll();

            if (valid) {
                let params = {
                    treatment_board_id: self.activity.treatment_board_id,
                    treatment_activity_type_id:
                        self.activity.treatment_activity_type_id,
                    due: self.activity.due,
                    // due_type: 1,
                    status: 1,
                    note: self.note,
                    action: self.action,
                    complete_at: Math.round(self.time.toSeconds()),
                    complete_by: this.$root.currentActor.id,
                    vitals: self.vitals
                        ? self.vitals.map(item => ({
                              vital_id: item.is_new ? "" : item.id,
                              master_vital_id: item.master_vital.id,
                              value: parseFloat(self.vitalValues[item.id]),
                              date: Math.round(self.time.toSeconds()),
                              time_taken: self.time.toFormat("h:mm a"),
                              patient_id:
                                  self.activity.treatment_board.patient_id,
                              master_uom_id: self.uomID[item.master_vital.id],
                              note: self.note,
                              status: 1,
                              soap_id: self.event?.treatment?.soap_id
                          }))
                        : null
                };

                try {
                    if (params) {
                        this.loading = true;
                        response = await this.$http.put(
                            process.env.BARRAMUNDI +
                                "schedule/activity/" +
                                self.activity.id,
                            params
                        );

                        if (response.status === 200) {
                            self.loading = false;
                            self.$refs.multipleVitalModal.hide();
                            self.$root.$emit("treatment-board-refresh", {
                                params: response.data.response,
                                treatment_board_id:
                                    self.activity.treatment_board_id
                            });
                            self.$socket.client.emit("v-broadcast-all", {
                                params: response.data.response,
                                action: "refresh-vital",
                                patient_id: this.patient.id,
                                businessId: this.$root.setting.business_id
                            });
                            self._message("Vitals saved", "success");
                        } else {
                            self.loading = false;
                            self._message("Error saving data", "danger");
                        }
                    }
                } catch (errors) {
                    self.loading = false;
                    self._message("Error saving data", "danger");
                }
            }
        },
        uom_label(masterVitalID) {
            switch (masterVitalID) {
                case 1: // Heart Rate
                    return [{ value: 67, text: "bpm" }];
                case 2: // Respiration
                    return [{ value: 68, text: "rpm" }];
                case 3: // Temperature
                    return [
                        { value: 69, text: "C" },
                        { value: 70, text: "F" }
                    ];
                case 4: // Weight
                    return [
                        { value: 72, text: "Kg" },
                        { value: 73, text: "G" },
                        { value: 75, text: "Lbs" },
                        { value: 76, text: "Oz" }
                    ];
                case 6: // Capillary Refill Time
                    return [{ value: 78, text: "seconds" }];
            }
        },
        triggerTreatmentboardAction(action) {
            this.$emit("activity-action", action, {
                treatment: this.event.treatment,
                activity: this.event.activity
            });
        }
    }
};
</script>
